import React from 'react';

const ShareCollectionIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.481 4.5535V0.225502L3.774 4.9325L0 8.7065L3.841 11.9075L8.481 15.7745V11.5395C16.627 10.9255 19.481 15.6395 19.481 15.6395C19.481 12.7025 19.239 9.6545 16.93 7.3465C14.246 4.6615 10.359 4.4715 8.481 4.5535Z" fill="#1CA5E0" />
  </svg>
);

export default ShareCollectionIcon;
